var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.jobPost
    ? _c("section", { staticClass: "main-content bg-light" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-6 offset-lg-3 col-12 p-0" }, [
            _c(
              "div",
              { staticClass: "p-3" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-outline-info",
                    attrs: { to: "/job-posts" }
                  },
                  [
                    _c("i", { staticClass: "fal fa-home-alt" }),
                    _vm._v(" หน้ารวมงาน\n        ")
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("section", { staticClass: "bg-white p-3" }, [
              _c("div", { staticClass: "d-flex text-secondary text-small" }, [
                _c("div", { staticClass: "flex-fill" }, [
                  _vm._v(
                    "\n            Job #" +
                      _vm._s(_vm.jobPost.code) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex-fill text-right" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm._f("prettyDate")(_vm.jobPost.created_at)) +
                      "\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "py-3 text-center" }, [
                _c("div", { staticClass: "job-post-title" }, [
                  _vm._v(_vm._s(_vm.jobPost.title))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "job-post-salary -status-alert mt-2" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("currency")(_vm.jobPost.min_salary)) +
                        " - " +
                        _vm._s(_vm._f("currency")(_vm.jobPost.max_salary)) +
                        " / เดือน\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "mt-4" }, [
                  _c("i", {
                    staticClass: "fas fa-map-marker-alt -status-alert"
                  }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("multiLangName")(_vm.jobPost.address_province)
                      ) +
                      " - " +
                      _vm._s(_vm._f("multiLangName")(_vm.jobPost.district)) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _vm.jobPost.job_users.length > 0
                  ? _c("div", { staticClass: "mt-2" }, [
                      _c("i", { staticClass: "fas fa-user" }),
                      _vm._v(
                        " มี " +
                          _vm._s(_vm.jobPost.job_users.length) +
                          " คนสนใจ\n          "
                      )
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "bg-white p-3 mt-3" }, [
              _c("h3", [_vm._v("สวัสดิการ")]),
              _vm._v(" "),
              _c("div", [
                _vm._m(0),
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.jobPost.has_accommodation === 0
                        ? "ไม่มีที่พักให้ (ไป-กลับ)"
                        : "มีที่พักให้"
                    ) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _vm.jobPost.job_post_welfares.length > 0
                ? _c("div", { staticClass: "mt-3" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "pl-4" },
                      _vm._l(_vm.jobPost.job_post_welfares, function(
                        item,
                        index
                      ) {
                        return _c("li", [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.job_welfare.name) +
                              "\n            "
                          )
                        ])
                      }),
                      0
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "bg-white p-3 mt-3" }, [
              _c("h3", [_vm._v("คุณสมบัติ")]),
              _vm._v(" "),
              _vm.jobPost.job_post_skills.length > 0
                ? _c("div", { staticClass: "mt-3" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "pl-4" },
                      _vm._l(_vm.jobPost.job_post_skills, function(
                        item,
                        index
                      ) {
                        return _c("li", [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.job_skill.name) +
                              "\n            "
                          )
                        ])
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.jobPost.job_post_languages.length > 0
                ? _c("div", { staticClass: "mt-3" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "pl-4 mb-0" },
                      _vm._l(_vm.jobPost.job_post_languages, function(
                        item,
                        index
                      ) {
                        return _c("li", [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.language.name) +
                              "\n            "
                          )
                        ])
                      }),
                      0
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "bg-white p-3 mt-3" }, [
              _c("h3", [_vm._v("รายละเอียดงาน")]),
              _vm._v(" "),
              _c("div", {
                directives: [{ name: "linkified", rawName: "v-linkified" }],
                domProps: {
                  innerHTML: _vm._s(_vm.handleNewLine(_vm.jobPost.description))
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.jobUser
          ? _c(
              "div",
              { staticClass: "bg-white bottom-button border-top p-2" },
              [
                !_vm.isInterestedJob(_vm.jobPost)
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-lg btn-outline-secondary btn-block p-2",
                        on: {
                          click: function($event) {
                            return _vm.addData()
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fas fa-plus" }),
                        _vm._v(" สนใจรับงานนี้\n    ")
                      ]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "btn btn-lg btn-info btn-block p-2",
                        on: {
                          click: function($event) {
                            return _vm.deleteData()
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fas fa-check" }),
                        _vm._v(" ลงชื่อสนใจรับงานนี้แล้ว\n    ")
                      ]
                    )
              ]
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("label", [_vm._v("ที่พัก")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("label", [_vm._v("สวัสดิการอื่น ๆ")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("label", [_vm._v("ทักษะที่ต้องการ")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("label", [_vm._v("ภาษา")])])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66a8aa1c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66a8aa1c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobPost/JobPostDetail.vue
// module id = 2212
// module chunks = 0